import fallback from '@utils/fallback'
import { inputHeight, spaceBetween } from '@utils/styles'

function initRegister(regId, initCallback, successCallback) {
  $('#' + regId).html('')
  window.initRegister(
    {
      successCallback: function($_el, data) {
        successCallback(data)
      }
    },
    function() {
      $('#' + regId).register({
        inputHeight: inputHeight(),
        spaceBetween: spaceBetween()
      })
      initCallback()
    }
  )
}

export default function(regId, initCallback, successCallback) {
  // 初使化注册
  if (!window.initRegister) {
    fallback('register', function(err) {
      if (!err) {
        initRegister(regId, initCallback, successCallback)
      }
    })
  } else {
    initRegister(regId, initCallback, successCallback)
  }

  return $('#' + regId)
}
